var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.getClasses,attrs:{"viewBox":_vm.svgViewBoxValues,"height":_vm.getHeight,"width":_vm.getWidth,"aria-hidden":_vm.getAriaHidden,"fill":_vm.getFill,"xmlns":"http://www.w3.org/2000/svg"},domProps:{"innerHTML":_vm._s(_vm.svgContent)}})
}
var staticRenderFns = []

export { render, staticRenderFns }